import { render, staticRenderFns } from "./OrderReplacementItem.vue?vue&type=template&id=27dbff33&scoped=true"
import script from "./OrderReplacementItem.vue?vue&type=script&lang=ts"
export * from "./OrderReplacementItem.vue?vue&type=script&lang=ts"
import style0 from "./OrderReplacementItem.vue?vue&type=style&index=0&id=27dbff33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dbff33",
  null
  
)

export default component.exports